define.alias("shared/components/shared/pre-boarding/social-connect/index", "preview-grid/components/shared/pre-boarding/social-connect/index");